import { render } from "./NewSpentPage.vue?vue&type=template&id=6f7593d2&ts=true"
import script from "./NewSpentPage.vue?vue&type=script&lang=ts"
export * from "./NewSpentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__